/**
 * Форматирование ФИО врача в отзывах.
 * Полное ФИО хранится в employeeName; на карточке показываем «Фамилия И.О.».
 */
export function formatDoctorShortName(fullName) {
  const parts = String(fullName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (!parts.length) return ''
  if (parts.length === 1) return parts[0]
  const surname = parts[0]
  const initials = parts
    .slice(1)
    .map((p) => (p[0] ? `${p[0].toUpperCase()}.` : ''))
    .join('')
  return `${surname} ${initials}`.trim()
}
